// extracted by mini-css-extract-plugin
module.exports = {"inner":"USP_inner__j9wg3","left":"USP_left__wN7gn","common":"USP_common__EN7ft","list":"USP_list__bySI2","asset":"USP_asset__iDsYi","assetBackground":"USP_assetBackground__iGeaY"};